import { render, staticRenderFns } from "./SellingCostDetailTable.vue?vue&type=template&id=6ca45ba4&scoped=true"
import script from "./SellingCostDetailTable.vue?vue&type=script&lang=js"
export * from "./SellingCostDetailTable.vue?vue&type=script&lang=js"
import style0 from "./SellingCostDetailTable.vue?vue&type=style&index=0&id=6ca45ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca45ba4",
  null
  
)

export default component.exports